document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.section');

  const options = {
    root: null,
    rootMargin: '0px 0px 200px 0px',
    threshold: 0.01
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, options);

  sections.forEach(section => {
    observer.observe(section);
  });
});